import { render, staticRenderFns } from "./pointList.vue?vue&type=template&id=1933add2&scoped=true&"
import script from "./pointList.vue?vue&type=script&lang=js&"
export * from "./pointList.vue?vue&type=script&lang=js&"
import style0 from "./pointList.vue?vue&type=style&index=0&id=1933add2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1933add2",
  null
  
)

export default component.exports